import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
// @mui
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Link,
  Stack,
  Typography
} from '@mui/material';
// graphql
import { CLIENT_EMAIL_VERIFICATION } from 'src/graphQL/queries';
// layout
import AuthPortalLayout from '../../../layouts/auth/AuthPortalLayout';
import { AUTH_PORTALS } from '../../../layouts/auth/portals';
// sections
import { LoginForm } from '../../../sections/auth/clientAuth/login';

// ----------------------------------------------------------------------

export default function Login() {
  const [isVerified, setIsVerified] = useState(true);
  const [resendEmail, { data, loading }] = useLazyQuery(
    CLIENT_EMAIL_VERIFICATION
  );
  const [email, setEmail] = useState('');

  const handleResend = async () => {
    await resendEmail({ variables: { email } });
  };

  return (
    <AuthPortalLayout
      portal={AUTH_PORTALS.client}
      title={isVerified ? 'Sign in to Client Planet' : 'Check your email'}
      subtitle={
        isVerified
          ? 'Enter your details below.'
          : 'We sent you a verification link.'
      }
    >
      {isVerified ? (
        <LoginForm setEmail={setEmail} setIsVerified={setIsVerified} />
      ) : (
        <Stack spacing={2}>
          {data && <Alert severity="success">Email sent!</Alert>}
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            We sent a verification link to:
          </Typography>
          <Link href={`mailto:${email}`} underline="always">
            {email}
          </Link>
          <Box>
            <Button
              variant="contained"
              onClick={() => handleResend()}
              disabled={loading}
              sx={{ mt: 1 }}
            >
              {loading ? (
                <CircularProgress size={22} sx={{ color: 'common.white' }} />
              ) : (
                'Resend link'
              )}
            </Button>
          </Box>
        </Stack>
      )}
    </AuthPortalLayout>
  );
}
